export default __webpack_public_path__ + "e8b084d80f399c293af3ab116ee5d1a4.png";